import TituloMain from "../titles/TituloMain"

import './header.css'
const Header = () => {
  return (
    <>
    <div className="header">
        <img src={require('../../assets/logoPoptelera.png')} alt="Logo Poptelera"/>
        <TituloMain>Gestión Repertorios</TituloMain>
        <img src={require('../../assets/logoPoptelera.png')} alt="Logo Poptelera"/>
    </div>
    </>
  )
}
export default Header